import { saleCloseoutRepo } from '../repo';

export const saleCloseoutService = {
    async getAll(params = {}) {
        try {
            const response = await saleCloseoutRepo.getAll(params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getById(closeoutId) {
        if (!closeoutId) {
            throw new Error('Closeout ID is required');
        }

        try {
            const response =
                await saleCloseoutRepo.getById(closeoutId);

            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getByShop(shopId, params = {}) {
        if (!shopId) {
            throw new Error('Shop ID is required');
        }

        try {
            const response =
                await saleCloseoutRepo.getByShop(
                    shopId,
                    params
                );

            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getTotalByShop(shopId, params = {}) {
        if (!shopId) {
            throw new Error('Shop ID is required');
        }

        try {
            const response =
                await saleCloseoutRepo.getTotalByShop(
                    shopId,
                    params
                );

            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getBySeller(shopSellerId, params = {}) {
        if (!shopSellerId) {
            throw new Error('Shop seller ID is required');
        }

        try {
            const response =
                await saleCloseoutRepo.getBySeller(
                    shopSellerId,
                    params
                );

            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getTotalBySeller(shopSellerId, params = {}) {
        if (!shopSellerId) {
            throw new Error('Shop seller ID is required');
        }

        try {
            const response =
                await saleCloseoutRepo.getTotalBySeller(
                    shopSellerId,
                    params
                );

            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async create(data) {
        if (!data.shopSellerId) {
            throw new Error('Shop seller ID is required');
        }

        if (!data.shopId) {
            throw new Error('Shop ID is required');
        }

        if (!data.amount || Number(data.amount) <= 0) {
            throw new Error('Valid amount is required');
        }

        try {
            const response =
                await saleCloseoutRepo.create(data);

            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async update(closeoutId, data) {
        if (!closeoutId) {
            throw new Error('Closeout ID is required');
        }

        try {
            const response =
                await saleCloseoutRepo.update(
                    closeoutId,
                    data
                );

            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getStats(params = {}) {
        try {
            const response =
                await saleCloseoutRepo.getAll({
                    per_page: 1000,
                    ...params,
                });

            const closeouts = response.data?.data || [];

            const totalAmount = closeouts.reduce(
                (sum, closeout) =>
                    sum + parseFloat(closeout.amount || 0),
                0
            );

            return {
                total: closeouts.length,
                total_amount: totalAmount,
            };
        } catch (error) {
            throw this.handleError(error);
        }
    },

    handleError(error) {
        console.error(
            'SaleCloseoutService Error:',
            error
        );

        return error.response?.data || error;
    },
};